// import React from 'react';

// const Banner = () => {
//   return (
//     <div className="bg-white py-20 flex items-center justify-center relative font-Questrial">
//       <div
//         className="bg-cover bg-center p-8 md:px-16 rounded-2xl shadow-lg max-w-6xl mx-auto relative bg-[#5c68f2]"
//         style={{ backgroundImage: "url('/assets/CircularOne-Bn-i-OzO.webp')" }}
//       >
//         <div className="flex flex-col items-center text-center lg:py-10">
//           <h1 className="text-4xl text-white font-medium tracking-tight sm:text-3xl md:text-[30px] font-Calistoga">
//             <span className="block mb-4">Seamless Resource Optimization,</span>
//             <div className="mt-4">Forging Growth</div>
//           </h1>
//           <p className="mx-auto mt-6 max-w-xl text-base text-white sm:mt-8 lg:text-[17px]">
//             Talk to our experts to Engage, Retain and Grow through our Resource-as-a-service solutions.
//           </p>

//           {/* Decorative floating images */}
//           <div className="hidden lg:flex relative">
//             <div className="absolute -top-56 left-72 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden balloon">
//               <img src="https://www.navishaa.com/assets/powerapp-CWh0_WUX.png" alt="Copilot" className="object-cover w-full h-full" />
//             </div>
//             <div className="absolute -top-56 right-72 transform translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden balloon">
//               <img src="https://www.navishaa.com/assets/M365-CJftAqtU.png" alt="Azure" className="object-cover w-full h-full" />
//             </div>
//             <div className="absolute -bottom-36 left-72 transform -translate-x-1/2 translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden balloon">
//               <img src="https://www.navishaa.com/assets/Copilot-DhV6uIFg.jpg" alt="Power Apps" className="object-cover w-full h-full" />
//             </div>
//             <div className="absolute -bottom-36 right-72 transform translate-x-1/2 translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden balloon">
//               <img src="https://www.navishaa.com/assets/microsoftAzure-Dc7UFzJF.png" alt="M365" className="object-cover w-full h-full" />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:gap-6 md:mt-10">
//             <button className="inline-flex items-center justify-center rounded-md bg-white px-6 py-1.5 text-base font-medium text-blue-700 hover:text-[#ba195f] transition duration-300 ease-in-out md:text-lg">
//               Hire On-demand
//             </button>
//             <button className="inline-flex items-center justify-center rounded-md bg-white px-6 py-1.5 text-base font-medium text-blue-700 hover:text-[#ba195f] transition duration-300 ease-in-out md:text-lg">
//               Outsource Project
//             </button>
//             <button className="inline-flex items-center justify-center rounded-md bg-white px-6 py-1.5 text-base font-medium text-blue-700 hover:text-[#ba195f] transition duration-300 ease-in-out md:text-lg">
//               Offshore CoE
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Banner;

import React from "react";

const Banner = () => {
  return (
    <div className="bg-white py-12 flex items-center justify-center relative font-Questrial">
      <div
        className="bg-cover bg-center p-6 md:px-10 rounded-xl shadow-lg max-w-2xl mx-auto relative bg-[#5c68f2]"
        style={{ backgroundImage: "url('https://res.cloudinary.com/dbitupkaa/image/upload/v1747380674/CircularOne-Bn-i-OzO_owe1e8.webp')" }}
      >
        <div className="flex flex-col items-center text-center lg:py-12">
          <h1 className="text-2xl text-white font-medium tracking-tight sm:text-xl md:text-[30px] font-Calistoga">
            <span className="block mb-2">Seamless Resource Optimization,</span>
            <div className="mt-2">Forging Growth</div>
          </h1>
          <p className="mx-auto mt-4 max-w-md text-sm text-white sm:mt-5">
            Talk to our experts to Engage, Retain and Grow through our
            Resource-as-a-service solutions.
          </p>
          

          {/* Floating Decorative Images */}
          <div className="hidden lg:flex relative">
            <div className="absolute -top-40 left-56 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden">
              <img
                src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747379752/Copilot-DhV6uIFg_mdx1cs.jpg"
                alt="Copilot"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute -top-40 right-56 transform translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden">
              <img
                src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747379733/microsoftAzure-Dc7UFzJF_upzqaw.png"
                alt="Azure"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute -bottom-20 left-56 transform -translate-x-1/2 translate-y-1/2 w-10 h-10 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden">
              <img
                src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747379780/powerapp-CWh0_WUX_wvd4ff.png"
                alt="Power Apps"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute -bottom-20 right-56 transform translate-x-1/2 translate-y-1/2 w-10 h-10 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden">
              <img
                src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747379767/M365-CJftAqtU_wgyfuu.png"
                alt="M365"
                className="object-cover w-full h-full"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:gap-4">
            <button className="inline-flex items-center justify-center rounded-md bg-white px-4 py-1 text-sm font-medium text-blue-700 hover:text-[#ba195f] transition duration-300">
              Hire On-demand
            </button>
            <button className="inline-flex items-center justify-center rounded-md bg-white px-4 py-1 text-sm font-medium text-blue-700 hover:text-[#ba195f] transition duration-300">
              Outsource Project
            </button>
            <button className="inline-flex items-center justify-center rounded-md bg-white px-4 py-1 text-sm font-medium text-blue-700 hover:text-[#ba195f] transition duration-300">
              Offshore CoE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
